<template>
	<table class="table-installment w-100 typo-body-2 mt-4">
		<thead>
			<tr>
				<th>Plan name</th>
				<th>
					Plan info
				</th>
				<th>Minimum order</th>
				<th>Maximum order</th>
				<th>Status</th>
				<th>Type</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="plan in plans" :key="plan.id">
				<td class="plan-name">{{ plan.planName }}</td>
				<td>
					<div>{{ plan.interestRate }}%</div>
					<span class="typo-caption-2 color-black-45 inline-colunm">{{ plan.period }} month(s)</span>
				</td>
				<td>
					<template v-if="plan.minOrderAmount">
						{{ plan.minOrderAmount | priceFormat }}
					</template>
					<template v-else>
						-
					</template>
				</td>
				<td>
					<template v-if="plan.maxOrderAmount">
						{{ plan.maxOrderAmount | priceFormat }}
					</template>
					<template v-else>
						-
					</template>
				</td>
				<td>
					<CBadge class="badge-status" :color="plan.periodStatus.color">
						{{ plan.periodValue }}
					</CBadge>
				</td>
				<td>{{ plan.customAttributes.promotionType }}</td>
				<td>
					<router-link
						:to="{
							name: channelId ? 'InstallmentPlanChannelEdit' : 'InstallmentPlanEdit',
							params: {
								id: groupId,
								methodId: methodId,
								channelId: channelId,
								planId: plan.id,
							}
						}"
						class="icon-edit-plan"
					>
						<CIcon class="mr-2" name="cil-pencil" />
					</router-link>
				</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
export default {
	name: 'BaseTableInstallmentKTC',

	props: {
		groupId: {
			type: Number,
			default: null,
		},
		methodId: {
			type: Number,
			default: null,
		},
		plans: {
			type: Array,
			default: () => [],
		},
		channelId: {
			type: Number,
			default: null,
		},
	},
};
</script>

<style lang="scss" scoped>
	.table-installment {
		color: $color-black-90;

		tbody {
			box-shadow: 0 0 0 1px $color-gray-400;
			border-radius: 4px;
		}

		td,
		th {
			padding: rem(12);
			vertical-align: text-top;

			&:first-child {
				width: 20%;
			}
		}

		th {
			white-space: pre;
		}

		tr {
			> td, > th {
				padding-left: rem(16);
			}
		}
	}

	.icon-edit-plan {
		@include typo-body-2;

		cursor: pointer;
		color: $color-black-45;
		font-weight: 500;

		&:hover {
			color: $color-hypertext;
		}
	}

	.inline-colunm {
		white-space: nowrap;
	}

	.plan-name {
		@include ellipsisOneline;

		max-width: 130px;
	}
</style>
